// src/pages/TalleresCrear/utils.js
import dayjs from "dayjs";
import { diasOrder } from "./constants";

export const formatCLP = (value) => {
  if (value == null || value === "") return "";
  const n = Number(value);
  if (Number.isNaN(n)) return "";
  return n.toLocaleString("es-CL");
};

export const parseCLP = (value) => {
  if (value == null || value === "") return undefined;
  const cleaned = String(value).replace(/\./g, "").replace(/\s/g, "");
  const n = Number(cleaned);
  return Number.isNaN(n) ? undefined : n;
};

export const sortDias = (arr) => [...arr].sort((a, b) => diasOrder.indexOf(a) - diasOrder.indexOf(b));

export const diffInMonthsApprox = (startISO, endISO) => {
  if (!startISO || !endISO) return null;
  const start = dayjs(startISO);
  const end = dayjs(endISO);
  if (!start.isValid() || !end.isValid()) return null;
  if (end.isBefore(start)) return 0;
  const totalDays = end.diff(start, "day");
  return Math.ceil(totalDays / 30);
};

export const getAllowedPlans = (startISO, endISO) => {
  if (!startISO) return ["mensual", "trimestral", "semestral", "anual"];
  if (!endISO) return ["mensual", "trimestral", "semestral", "anual"];
  const m = diffInMonthsApprox(startISO, endISO);
  if (m === null) return ["mensual", "trimestral", "semestral", "anual"];
  if (m <= 0) return ["mensual"];
  if (m <= 2) return ["mensual"];
  if (m <= 5) return ["mensual", "trimestral"];
  if (m <= 11) return ["mensual", "trimestral", "semestral"];
  return ["mensual", "trimestral", "semestral", "anual"];
};

export const getNombreRecinto = (recintoId, recintosArray) => {
  const recinto = recintosArray.find(r => r.value === recintoId);
  return recinto ? recinto.label : "-";
};
